import { Col, Logo, Row } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${(props) => (props.isMobile ? '100vh' : 'calc(100vw - 57%)')};
  background-color: ${theme.GREY_10};
  overflow: hidden;
  ${(props) => props.isMobile && 'display: none;'};
`;

const Image = styled.img`
  height: calc(100vh + 100px);
  position: fixed;
  right: 57%;
`;

const Container = ({ children, navigation }) => {
  const [resetStep, setResetStep] = useState('Email'),
    [email, setEmail] = useState(''),
    { isMobile } = useSelector((state) => state.appState);

  return (
    <React.Fragment>
      <ImageWrapper isMobile={isMobile}>
        <Image src={require('assets/branding/logo-icon-grey-20.png')} />
      </ImageWrapper>

      <Col centerAll>
        <Row className="row" between pad="0 16px" ht="100vh" wid={isMobile ? '100%' : '936px'}>
          {!isMobile && <Col center wid="50%" noFlex marg="0 0 0"></Col>}

          <Col center wid={isMobile ? '100vw' : '50%'} noFlex>
            <Col center noFlex ht="100vh" wid={isMobile ? '100vw' : '297px'}>
              <Col centerAll start marg="120px 0 0" wid={isMobile ? '100vw' : '456px'}>
                <Logo wid="296px" />

                {children}
              </Col>
            </Col>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default Container;
